import { Typography } from '@material-ui/core'
import React from 'react'

import { getTranslate } from '../../../localization'
import { ChangedField } from '../../../types/auditLogs'
import useStyles from './styles/changedFieldsTable.styles'

interface ChangedFieldsTableProps {
  data: ChangedField[]
}

const ChangedFieldsTable: React.FC<ChangedFieldsTableProps> = ({ data }) => {
  const classes = useStyles()

  return (
    <>
      <Typography className={classes.contentTitlesHeader} variant="h2">
        {getTranslate('Changed Fields')}
      </Typography>
      <div className={classes.entitiesContainerWrapper}>
        <div className={classes.entitiesContainer}>
          <div className={classes.entitiesTableHeader}>
            <div>
              <Typography variant="body1">
                {getTranslate('Field Name')}
              </Typography>
            </div>
            <div>
              <Typography variant="body1">
                {getTranslate('Old Value')}
              </Typography>
            </div>
            <div>
              <Typography variant="body1">
                {getTranslate('New Value')}
              </Typography>
            </div>
          </div>
          {data.map((item, ii) => (
            <div key={ii} className={classes.tableRow}>
              <Typography>{item.field}</Typography>
              <Typography>{item.oldValue}</Typography>
              <Typography>{item.newValue}</Typography>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default ChangedFieldsTable
